// Converts between a review form's state and a saved review draft.

export const draftFromForm = ({ ratings = {}, comments = {}, starScores = {} }, questionIds) => ({
  responses: questionIds
    .filter(qId => ratings[qId] || starScores[qId] || comments[qId])
    .map(qId => ({
      question_id: qId,
      rating: starScores[qId] || 0,
      rating_label: ratings[qId] || "",
      comment: comments[qId] || "",
    })),
  overallComment: comments.overallComment || "",
});

// Answers to questions no longer on the template are dropped: they'd skew the
// overall score worked out from the star scores.
export const formFromDraft = (draft, sections = []) => {
  const questionIds = sections.flatMap(s => (s.questions || []).map(q => q.id));
  const form = { ratings: {}, comments: {}, starScores: {} };

  (draft?.responses || [])
    .filter(r => questionIds.includes(r.question_id))
    .forEach(r => {
      if (r.rating_label) form.ratings[r.question_id] = r.rating_label;
      if (r.rating) form.starScores[r.question_id] = r.rating;
      if (r.comment) form.comments[r.question_id] = r.comment;
    });
  if (draft?.overall_comment) form.comments.overallComment = draft.overall_comment;

  return form;
};
